<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="繁体轮播图" prop="bannerUrl">
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.bannerUrl"
          :showUploadList="false"
          :customRequest="handleChange"
        >
          <img v-if="form.bannerUrl" :src="form.bannerUrl" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="简体轮播图" prop="bannerUrlCn">
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.bannerUrlCn"
          :showUploadList="false"
          :customRequest="handleChangeCn"
        >
          <img v-if="form.bannerUrlCn" :src="form.bannerUrlCn" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoadingCn ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="英文轮播图" prop="bannerUrlEn">
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.bannerUrlEn"
          :showUploadList="false"
          :customRequest="handleChangeEn"
        >
          <img v-if="form.bannerUrlEn" :src="form.bannerUrlEn" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="马来语轮播图" prop="bannerUrlBm">
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.bannerUrlBm"
          :showUploadList="false"
          :customRequest="handleChangeBm"
        >
          <img v-if="form.bannerUrlBm" :src="form.bannerUrlBm" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoadingBm ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="印尼语轮播图" prop="bannerUrlIn">
        <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form.bannerUrlIn"
            :showUploadList="false"
            :customRequest="handleChangeIn"
        >
          <img v-if="form.bannerUrlIn" :src="form.bannerUrlIn" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoadingIn ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>




      <a-form-model-item label="视频" prop="videoUrl">
        <a-upload
          listType="picture-card"
          accept=".mp4"
          class="avatar-uploader"
          v-model="form.videoUrl"
          :showUploadList="false"
          :customRequest="handleVideo"
        >
          <div v-if="videoUrl">
            <video :src="videoUrl" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if=" this.uploadSize!= 0" :percent=this.uploadSize />
      </a-form-model-item>


      <a-form-model-item label="英文视频" prop="videoUrlEn">
        <a-upload
          listType="picture-card"
          accept=".mp4"
          class="avatar-uploader"
          v-model="form.videoUrlEn"
          :showUploadList="false"
          :customRequest="handleVideoEn"
        >
          <div v-if="videoUrlEn">
            <video :src="videoUrlEn" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if=" this.uploadEnSize!= 0" :percent=this.uploadEnSize />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入排序"/>
      </a-form-model-item>
      <a-form-model-item label="所属" prop="bannerType">
        <a-select placeholder="请选择" v-model="form.bannerType">
          <a-select-option :key="0">APP</a-select-option>
          <a-select-option :key="1">PC</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="imgType">
        <a-select placeholder="请选择" v-model="form.imgType">
          <a-select-option :key="0">轮播图</a-select-option>
          <a-select-option :key="1">广告图</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="跳转类型" prop="type">
        <a-select placeholder="请选择跳转类型" @change="updateType" v-model="form.type">
          <a-select-option :key="0">短剧</a-select-option>
          <a-select-option :key="1">外部链接</a-select-option>
          <a-select-option :key="2">充值页面</a-select-option>
          <a-select-option :key="3">签到</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.type==0" label="是否跳转" prop="isJump">
        <a-select placeholder="请选择是否跳转" @change="updateIsGo" v-model="form.isJump">
          <a-select-option :key="false">否</a-select-option>
          <a-select-option :key="true">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.type==1" label="外部链接" prop="linkUrl">
        <a-input v-model="form.linkUrl" placeholder="请输入外部链接"/>
      </a-form-model-item>
      <a-form-model-item v-if="this.isJup && this.type==0" label="短剧" prop="videoId">
        <a-select
          v-model="form.videoId"
          showSearch
          style="width: 100%"
          placeholder="请选择短剧"
          allow-clear
          optionFilterProp="children"
        >
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item,index) in listAll">
            {{ item.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getBanner, addBanner, updateBanner} from '@/api/banner/banner'
import {listVideo} from "@/api/video/video";
import UploadFileToVOD from "@/api/vod.js"
import UploadFileToOSS from "@/utils/upload-file-to-oss";

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      uploadLoading: false,
      uploadLoadingCn: false,
      uploadLoadingBm: false,
      uploadLoadingEn: false,
      uploadLoadingIn: false,
      process: false,
      formTitle: '',
      videoUrl: '',
      videoUrlEn: '',
      uploadSize: 0,
      uploadEnSize: 0,
      fileList: [],
      type: 0,
      listAll: [],
      isJup: false,
      // 表单参数
      form: {
        id: null,

        sort: null,

        videoId: null,

        isJump: false,
        linkUrl: null,
        videoUrl: null,
        videoUrlEn: null,
        bannerType: null,
        imgType: null,
        type: null,

        bannerUrl: null,
        bannerUrlCn: null,
        bannerUrlBm: null,
        bannerUrlEn: null,
        bannerUrlIn: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        sort: [
          {required: true, message: '排序不能为空'}
        ],
        isJump: [
          {required: true, message: '是否跳转不能为空'}
        ],
        linkUrl: [
          {required: true, message: '外部链接不能为空'}
        ],
        bannerUrl: [
          {required: true, message: '繁体轮播图url不能为空'}
        ]
      }
    }
  },
  filters: {},
  created() {
    this.getGather();
    this.uploadSize = 0
    this.uploadEnSize = 0
  },
  computed: {},
  watch: {},
  mounted() {
  },

  methods: {
    handleChange(info) {
      this.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          this.$nextTick(() => {  // 确保 DOM 更新
            this.form.bannerUrl = fileName[0]  // 直接赋值
            this.uploadLoading = false
          })
        }
      })

      // new UploadFileToVOD([info.file], {
      //   success: function (fileName) {
      //     that.form.bannerUrl = fileName[0];//文件名
      //     that.uploadLoading = false;
      //   },
      // });
      // that.uploadLoading = false;
    },
    handleChangeCn(info) {
      this.uploadLoadingCn = true
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          this.$nextTick(() => {  // 确保 DOM 更新
            this.form.bannerUrlCn = fileName[0]  // 直接赋值
            this.uploadLoadingCn = false
          })
        }
      })
    },
    handleChangeBm(info) {
      this.uploadLoadingBm = true
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          this.$nextTick(() => {  // 确保 DOM 更新
            this.form.bannerUrlBm = fileName[0]  // 直接赋值
            this.uploadLoadingBm = false
          })
        }
      })
    },
    handleChangeIn(info) {
      this.uploadLoadingIn = true
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          this.$nextTick(() => {  // 确保 DOM 更新
            this.form.bannerUrlIn = fileName[0]  // 直接赋值
            this.uploadLoadingIn = false
          })
        }
      })
    },

    handleChangeEn(info) {

      this.uploadLoadingEn = true
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          this.$nextTick(() => {  // 确保 DOM 更新
            this.form.bannerUrlEn = fileName[0]  // 直接赋值
            this.uploadLoadingEn = false
          })
        }
      })

      // let that = this
      // new UploadFileToVOD([info.file], {
      //   success: function (fileName) {
      //     that.form.bannerUrlEn = fileName[0];//文件名
      //     that.uploadLoadingEn = false;
      //   },
      // });
      // that.uploadLoadingEn = false;
    },

    handleVideo(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      let that = this

      that.videoUrl = ""
      // new UploadFileToOSS([info.file], {
      //   success: function (fileName) {
      //
      //     that.videoUrl = fileName[0].url;//文件名
      //     that.uploadLoading = false;
      //   },
      //   vProgress: function (val) {
      //     that.uploadSize = val * 100;
      //   }
      // });

      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.videoUrl = fileName[0];//文件名
          that.uploadLoading = false;
        },
        vProgress: function (val) {
          that.uploadSize = val * 100;
        }
      });
      that.uploadLoading = false;

    },

    handleVideoEn(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingEn = true;
        return;
      }
      let that = this

      that.videoUrlEn = ""
      // new UploadFileToOSS([info.file], {
      //   success: function (fileName) {
      //
      //     that.videoUrlEn = fileName[0].url;//文件名
      //     that.uploadLoadingEn = false;
      //   },
      //   vProgress: function (val) {
      //     that.uploadEnSize = val * 100;
      //   }
      // });
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.videoUrlEn = fileName[0];//文件名
          that.uploadLoadingEn = false;
        },
        vProgress: function (val) {
          that.uploadSize = val * 100;
        }
      });
      that.uploadLoadingEn = false;

    },


    updateType(value) {
      this.type = value
    },
    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading = false
        return false;
      }
      //TODO 驗證文件大小
    },
    updateIsGo(value) {
      this.isJup = value
    },
    onClose() {
      this.isJup = false
      this.uploadSize = 0
      this.uploadEnSize = 0
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    getGather() {
      listVideo({isRelease: 1}).then(res => {
        this.listAll = res.data;
      })
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.videoUrl=''
      this.form = {
        id: null,
        sort: null,
        videoId: null,
        isJump: null,
        bannerUrl: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBanner({"id": id}).then(response => {
        this.form = response.data
        this.videoUrl=this.form.videoUrl
        this.videoUrlEn=this.form.videoUrlEn
        this.isJup = this.form.isJump
        this.type = this.form.type
        var fal = 0;
        for (var element of this.listAll) {
          if (element.id === this.form.videoId) {
            fal = 1
          }
        }
        if (fal == 0) {
          this.form.videoId=''
        }
        this.open = true
        this.formTitle = '修改'
      })


    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.videoUrl=this.videoUrl
          this.form.videoUrlEn=this.videoUrlEn
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBanner(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            this.form.videoUrl=this.videoUrl
            this.form.videoUrlEn=this.videoUrlEn
            addBanner(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
